module.exports = __webpack_public_path__ + "ClientApp/content/mary-sam-and-duncan-small.jpg";